export const env = {
  appName: 'Ciomy',
  environment: import.meta.env.MODE,
  queryDebug: import.meta.env.VITE_QUERY_DEBUG || true,

  apiBaseUrl: import.meta.env.VITE_API_BASEURL || 'https://ciomy-camunda.merapi.alurkerja.com',
  apiTasklistBaseUrl: import.meta.env.VITE_API_TASKLIST_BASEURL || 'https://ciomy-camunda.merapi.alurkerja.com',

  keycloakUrl: import.meta.env.VITE_KEYCLOAK_URL || 'https://keycloak.merapi.javan.id',
  keycloakRealm: import.meta.env.VITE_KEYCLOAK_REALM || 'ciomy',
  keycloakClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'ciomy',

  sentryDsn: import.meta.env.VITE_SENTRY_DSN,

  showMetabase:import.meta.env.VITE_SHOW_METABASE || 'all',
  iFrameMetabaseKehadiran:
    import.meta.env.VITE_IFRAME_METABASE_KEHADIRAN ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/8f320005-9016-44db-9ee1-5aab9a650ac9',
  iFrameMetabaseReimburse:
    import.meta.env.VITE_IFRAME_METABASE_REIMBURSE ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/e4255b9a-95fa-4bef-98dd-ae31440a55f4',
  iFrameMetabaseLembur:
    import.meta.env.VITE_IFRAME_METABASE_LEMBUR ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/6e530774-8fde-4600-8cee-990e0b43384f',
  iFrameMetabaseDinas:
    import.meta.env.VITE_IFRAME_METABASE_DINAS ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/4e8fb35a-45b8-4e61-944a-4b0de28f253a',
  iFrameMetabaseKPIHarian:
    import.meta.env.VITE_IFRAME_METABASE_KPI_HARIAN ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/9dc1bda0-d67c-40b8-8b0b-9b2488094d95',
  iFrameMetabaseLoan:
    import.meta.env.VITE_IFRAME_METABASE_LOAN ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/283e2610-c154-4b7f-bc75-be6719ec9c99',
  iFrameMetabaseBeasiswa:
    import.meta.env.VITE_IFRAME_METABASE_BEASISWA ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/7e329d1e-ae31-4e86-b50a-47511683185c',
  iFrameMetabaseCuti:
    import.meta.env.VITE_IFRAME_METABASE_CUTI ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/57f52e17-7034-4e57-9713-ca7672c4436a',
  iFrameMetabaseKpiLeadership:
    import.meta.env.VITE_IFRAME_METABASE_KPI_LEADERSHIP ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/ed5c3752-469d-42d8-9f89-4baae000a517',
  iFrameMetabaseKpiGRD:
    import.meta.env.VITE_IFRAME_METABASE_KPI_GRD ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/4ae60967-ce76-4add-b971-d27fc107dbe9',
  iFrameMetabaseKpiBulanan:
    import.meta.env.VITE_IFRAME_METABASE_KPI_BULANAN ||
    'https://kantorjogja.merapi.javan.id/public/dashboard/d98c54f3-e8ef-456e-8d26-026d2fcd8808',
}
